<template>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm header-nav">
    <div class="container super-container d-flex justify-content-center">
        <div class="col-4 d-flex align-items-center">
          <a href="https://www.petersco.com/" class="navbar-brand">
            <img src="@/assets/images/PetersLogo.png" class="nav-logo" alt="" />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <div class="col-8 d-flex justify-content-end align-items-center">
          <div class="p-2">
            <ul class="nav navbar-nav flex-row float-right">
              <li v-if="isLoggedIn" class="nav-item dropdown d-none d-md-block">
                <a
                  class="nav-link nav-link-welcome dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ userName }}
                </a>

                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link class="dropdown-item" to="/changepassword"
                    >Change Password</router-link
                  >
                  <li>
                    <a class="dropdown-item clickable" @click="signOut"
                      >Log Out</a
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
    </div>
  </nav>

  <div class="bg-white menu-spacing" id="menuBar">
    <div class="container">
      <div class="navbar-collapse collapse d-sm-flex">
        <ul class="nav navbar-nav nav-flex">
          <li class="nav-item top-nav" v-if="canViewDocs">
            <router-link class="nav-link top-menu" to="/publications"
              >Recent Publications</router-link
            >
          </li>
          <li class="nav-item top-nav" v-if="canViewDocs">
            <router-link class="nav-link top-menu" to="/advancedsearch"
              >Advanced Search</router-link
            >
          </li>
          <li class="nav-item top-nav" v-if="canSendEmail">
            <router-link class="nav-link top-menu" to="/emailcomposer"
              >Energy Facts</router-link
            >
          </li>
          <li class="nav-item top-nav" v-if="canAccessCRM">
            <div class="nav-link top-menu clickable" @click="showCrmModal = true">
              CRM Sync
            </div>
          </li>
          <li class="nav-item top-nav" v-if="canViewUserActivity">
            <router-link class="nav-link top-menu" to="/useractivity"
              >User Activity</router-link
            >
          </li>
          <li
            class="nav-item dropdown"
            v-if="
              canViewEmailTemplates ||
              canViewUsers ||
              canViewRoles ||
              canViewCompanies ||
              canViewSectors ||
              canViewPublicationTypes ||
              canViewEventDownloads ||
              canViewHolidays
            "
          >
            <a
              class="nav-link top-menu dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Administration
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                v-if="canViewEmailTemplates"
                class="dropdown-item"
                to="/emailtemplates"
                >Email Templates</router-link
              >
              <router-link
                v-if="canViewUsers"
                class="dropdown-item"
                to="/users"
                >User Management</router-link
              >
              <router-link
                v-if="canViewCompanies"
                class="dropdown-item"
                to="/companies"
                >Company Management</router-link
              >
              <router-link
                v-if="canViewRoles"
                class="dropdown-item"
                to="/roles"
                >Roles</router-link
              >
              <router-link
                v-if="canViewSectors"
                class="dropdown-item"
                to="/sectors"
                >Sectors</router-link
              >
              <router-link
                v-if="canViewPublicationTypes"
                class="dropdown-item"
                to="/publicationtypes"
                >Publication Types</router-link
              >

              <router-link
                v-if="canViewHolidays"
                class="dropdown-item"
                to="/holidays"
                >Holidays</router-link
              >

              <router-link
                v-if="canViewEventDownloads"
                class="dropdown-item"
                to="/eventDownloads"
                >Event Downloads</router-link
              >

              <router-link
                v-if="canSendEmail"
                class="dropdown-item"
                to="/energyFactsSend"
                >Energy Facts Send Status</router-link
              >

              <router-link
                v-if="canSendEmail"
                class="dropdown-item"
                to="/images"
                >Images</router-link
              >
            </ul>
          </li>
          <li class="nav-item dropdown d-md-none d-sm-block" v-if="isLoggedIn">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Profile
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link class="dropdown-item" to="/changepassword"
                >Change Password</router-link
              >
              <li>
                <a class="dropdown-item clickable" @click="signOut">Log Out</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <transition name="modal">
    <modal
      v-if="showCrmModal"
      @cancel="showCrmModal = false"
      @confirm="confirmCrmSync()"
      :crmsync="true"
      size="s"
    >
      <template v-slot:header>
        <div class="title">Confirm Sync</div>
      </template>
      <template v-slot:body>
        <div class="d-flex justify-content-center">
          <div class="message">
            Are you sure you want to manually sync with Sugar CRM?
          </div>
        </div>
      </template>
    </modal>
  </transition>

  <!--begin:: Crm sync modal-->
  <transition name="modal">
    <modal
      v-if="showCrmSyncModal"
      @confirm="showCrmSyncModal = false"
      :crmsync="true"
      size="s"
    >
      <template v-slot:header>
        <div class="title">CRM SYNC</div>
      </template>
      <template v-slot:body>
        <div class="d-flex justify-content-center">
          <div class="message">
            CRM sync is already in progress. Please try again later.
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="w-100 w-100 d-flex justify-content-center m-3">
          <button
            class="btn btn-sm btn-modal btn-primary"
            @click="showCrmSyncModal = false"
          >
            OK
          </button>
        </div>
      </template>
    </modal>
  </transition>
  <!--end:: Crm sync modal-->

</template>
<script lang="ts">
import { ref, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { IMessage, IUser } from "@/store/common/Types";
import modal from "@/components/Modal.vue";
import { debounce } from "ts-debounce";
import JwtService from "@/core/services/JwtService";

export default {
  name: "NavBar",
  components: {
    modal,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const isLoggedIn = computed(() => store.getters.isUserAuthenticated);
    const userName = computed(() =>
      isLoggedIn ? store.getters.currentUser.firstName + " " + store.getters.currentUser.lastName : ""
    );
    const canViewDocs = computed(() => store.getters.userCanViewDocuments);
    const canViewUsers = computed(() => store.getters.userCanViewUsers);
    const canSendEmail = computed(() => store.getters.userCanSendEmail);
    const canAccessCRM = computed(() => store.getters.userSyncCRM);
    const canViewUserActivity = computed(() => store.getters.userActivityView);
    const canViewSectors = computed(() => store.getters.userCanCreateSectors || store.getters.userCanEditSectors);
    const canViewPublicationTypes = computed(() => store.getters.userCanCreatePublicationTypes || store.getters.userCanEditPublicationTypes);
    const canViewRoles = computed(() => store.getters.userCanCreateRoles || store.getters.userCanEditRoles);
    const canViewCompanies = computed(() => store.getters.userCanCreateCompanies || store.getters.userCanEditCompanies);
    const canViewEmailTemplates = computed(() => store.getters.userCanCreateEmailTemplates || store.getters.userCanEditEmailTemplates);
    const canViewHolidays = computed(() => store.getters.userCanCreateHolidays || store.getters.userCanEditHolidays);
    const canViewEventDownloads = computed(() => store.getters.userCanEditEventDownload);
    const showCrmSyncModal = ref(false);

    const signOut = () => {
      store.dispatch(Actions.LOGOUT).then(() => router.push({ name: "login" }));
    };

    let showCrmModal = ref(false);

    const debouncedConfirmCrmSync = debounce(async () => {      
      await store.dispatch(Actions.CRM_SYNC);
      showCrmModal.value = false;

      const [errorName] = Object.keys(store.getters.getCrmErrors);
      const error = store.getters.getCrmErrors[errorName] as string;

      if(error == "429"){
        showCrmSyncModal.value = true;
      }
    });

    async function confirmCrmSync() {
      debouncedConfirmCrmSync();
    }

    const refreshTokenMinutes = 10; // Check every 10 minutes to see if the token needs to be refreshed.
    async function refreshToken() {
      store.dispatch(Actions.VERIFY_AUTH, {
        api_token: JwtService.getToken(),
        refresh_token: JwtService.getRefreshToken(),
      });

      if (
        store.getters.isUserAuthenticated &&
        Object.keys(store.getters.currentUser).length === 0
      ) {
        store.dispatch(Actions.LOAD_LOGIN_USER);
        store.dispatch(Actions.LOAD_PERMISSION);
      }

      setTimeout(refreshToken, 1000 * 60 * refreshTokenMinutes); // Check to see if the token needs to be refreshed every 10 minutes.
    }

    refreshToken();

    return {
      isLoggedIn,
      userName,
      signOut,
      canViewDocs,
      canViewUsers,
      canSendEmail,
      canAccessCRM,
      canViewUserActivity,
      canViewSectors,
      canViewPublicationTypes,
      canViewRoles,
      canViewCompanies,
      canViewEmailTemplates,
      canViewHolidays,
      showCrmModal,
      confirmCrmSync,
      canViewEventDownloads,
      showCrmSyncModal
    };
  },
};
</script>
